<template>
    <div>
        <h3>
            Notes
            <v-btn :disabled="isLoading"
                   @click="newNoteShow = true"
                   class="text-none ml-2"
                   color="secondary darken-1"
                   fab
                   x-small>
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </h3>
        <v-col :key="firmNote.id"
               cols="12"
               justify="start"
               no-gutters
               v-for="firmNote in notes">
            <v-card>
                <v-card-subtitle>
                    {{ firmNote.note.author }}
                    <br/>
                    {{ firmNote.note.createdAt }}
                </v-card-subtitle>
                <v-card-text>
                    {{ firmNote.note.text }}
                </v-card-text>
            </v-card>
        </v-col>
        <v-dialog persistent
                  v-model="newNoteShow"
                  width="500px">
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-textarea :rules="[lengthRule(512)]"
                                counter
                                label="Note"
                                v-model="newNoteText"/>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="text-none"
                           color="secondary darken-1"
                           text
                           @click="
              () => {
                newNoteShow = false;
                newNoteText = '';
              }
            ">Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="isLoading || newNoteAdding || newNoteText && newNoteText.length === 0"
                           :loading="newNoteAdding"
                           @click="addNote"
                           class="text-none"
                           color="secondary darken-1"
                           text
                    >Add
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import brokerFirmService from "@/services/brokerfirm.service";

export default {
    name: "BrokerFirmNotesList",
    props: ['brokerFirmId'],
    data() {
        return {
            isLoading: false,
            newNoteShow: false,
            notes: null,
            newNoteText: null,
            newNoteAdding: false,
            requiredRule: v => !!v || "required",
            lengthRule: limit => v => !v || v.length <= limit || "exceeds " + limit + " characters",
        }
    },
    methods: {
        async addNote() {
            this.newNoteAdding = true;
            await brokerFirmService.addNote(this.brokerFirmId, this.newNoteText);
            this.newNoteAdding = false;
            this.isLoading = false;
            this.newNoteShow = false;
            this.newNoteText = null;
            this.loadNotes();
        },
        async loadNotes(){
            this.isLoading = true;
            this.notes = await brokerFirmService.getNotes(this.brokerFirmId);
            this.isLoading = false;
        }
    },
    async created() {
      await this.loadNotes();
    },
}
</script>

<style scoped>

</style>
